import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog'

export function AboutModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-black border-white/10 text-white max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-3xl font-heading font-bold mb-4">
            About PitchMetric
          </DialogTitle>
          <DialogDescription className="text-gray-400">
            Exclusive sports intelligence that gives you the information edge
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 mt-6 text-gray-300 leading-relaxed">
          <div>
            <h3 className="font-heading text-xl font-bold text-white mb-3">
              Our Mission
            </h3>
            <p>
              PitchMetric gives you access to insights that no one else has. We believe you deserve the same 
              information edge that professionals rely on—without spending hundreds of hours analyzing data 
              from hundreds of sources.
            </p>
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold text-white mb-3">
              What We Do
            </h3>
            <p>
              Our AI-powered platform uncovers hidden patterns and exclusive insights for every game. Each report reveals 
              intelligence from hundreds of hours of analysis—player dynamics, injury impacts, environmental factors, 
              advanced metrics, historical patterns, and more—all synthesized into cutting-edge intelligence with strategic 
              recommendations.
            </p>
            <p className="mt-3">
              We deliver insights that would take professionals weeks to uncover, automatically, for every game across major 
              sports leagues—giving you an information advantage others simply don't have.
            </p>
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold text-white mb-3">
              How It Works
            </h3>
            <p>
              Seven specialized AI agents work in parallel to uncover insights from official sources, databases, 
              and current feeds. Our Master Integrator synthesizes everything into exclusive intelligence reports that reveal 
              hidden patterns and provide strategic, data-driven recommendations you won't find anywhere else.
            </p>
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold text-white mb-3">
              For Everyone
            </h3>
            <p>
              Whether you're a casual fan or someone looking to make highly educated decisions, PitchMetric puts 
              cutting-edge intelligence at your fingertips. No subscriptions to multiple data services, no hours 
              of manual analysis—just exclusive insights that give you the information edge, delivered automatically.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

